<script>
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';
import request from '@/services/request';

export default {
    name: "modal-program-company",

    data() {
        return {
            errors: {},

            catalogue: new Catalogue(),

            form: {
                program_id: "",
                company_id: "",
            },

            assigned_companies: [],     // IDs ya seleccionados
            available_companies: [],    // filtrados
        }
    },

    methods: {
        closeModal() {
            this.errors = {};

            this.form = {
                program_id: "",
                company_id: "",
            };

            this.available_companies = [];

            this.$modal.hide("modalProgramCompany");
        },

        /** ======================================================
         *         FILTRAR EMPRESAS YA ASIGNADAS
         * ====================================================== */
        filterAvailable() {
            const all = this.catalogue.companies_buildings ?? [];

            this.available_companies = all.filter(company =>
                !this.assigned_companies.includes(company.id)
            );
        },

        /** ======================================================
         *           CREAR RELACIÓN (NO EDITA)
         * ====================================================== */
        async saveCompany() {

            let payload = {
                program_id: this.form.program_id,
                company_id: this.form.company_id
            };

            try {
                const { data } = await request.post("/programs_companies", payload);

                this.successNotification(data.message);

                this.closeModal();

                // Recargar TAB principal
                Event.$emit("event-reload-program-relations");

            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success"
        }),
    },

    created() {

        /**
         * EVENTO PARA ABRIR MODAL
         * SOLO CREA, SIN EDITAR
         */
        Event.$on("event-open-program-company", async (data) => {
            this.errors = {};

            // 1. empresas asignadas
            this.assigned_companies = data.assigned_companies ?? [];

            // 2. program_id obligatorio
            this.form.program_id = data.program_id;

            // 3. cargar catálogo
            await this.catalogue.get_companies_buildings();

            // 4. filtrar SIN REPETIDOS
            this.filterAvailable();

            this.$modal.show("modalProgramCompany");
        });

    }
}
</script>

<template>
    <modal name="modalProgramCompany" :width="'50%'" :height="'auto'" :click-to-close="false">

        <form @submit.prevent="saveCompany">

            <!-- Cerrar -->
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">Asignar Empresa</h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <!-- SELECT EMPRESAS -->
                    <div class="col-md-12">
                        <label>Empresa</label>
                        <select class="form-control" v-model="form.company_id">
                            <option value="">Seleccione una empresa</option>

                            <option v-for="c in available_companies"
                                    :key="c.id"
                                    :value="c.id">
                                {{ c.name }}
                            </option>
                        </select>

                        <div class="text-danger" v-if="errors.company_id">
                            {{ errors.company_id[0] }}
                        </div>
                    </div>

                    <!-- BOTONES -->
                    <div class="col-12 mt-4">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Asignar
                        </button>

                        <button type="button" @click="closeModal" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Cancelar
                        </button>

                    </div>

                </div>
            </div>

        </form>
        
    </modal>
</template>

<style scoped>
.text-danger {
    font-size: 12px;
}
</style>
